<template>
  <layout-main-inner title="受理单管理">
    <el-button
      v-if="permission.LVL2"
      slot="action"
      type="primary"
      @click="selectitem">新增受理单</el-button>
    <layout-card-wrap hasSlot>
      <template slot="form">
        <ent-auto-select
          v-model="config.vendorId"
          style="margin-right: 10px"
          :callback="()=> { handleCurrentChange(1) }" />

        <el-input
          v-model="config.workOrderCode"
          clearable
          style="width: 240px"
          placeholder="请输入受理单号"
          @clear="handleCurrentChange(1)">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"></el-button>
        </el-input>
      </template>
      <el-table
        border
        :data="list">
        <el-table-column
          width="140"
          label="单号"
          prop="workOrderCode">
          <template slot-scope="{ row }">
            <span>{{ row.workOrderCode }}</span>
            <el-tag v-if="row.status === 1">受理中</el-tag>
            <el-tag
              v-if="row.status === 2"
              type="success">已完成</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="企业名称"
          min-width="120"
          prop="vendorName"></el-table-column>
        <el-table-column
          label="服务产品"
          min-width="120">
          <template slot-scope="{ row }">
            <span>{{ row.serviceName }}-{{ row.serviceCategoryName }}</span>
            <span v-if="row.servicePackageId">-{{ row.servicePackageName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          width="100"
          label="行业">
          <template slot-scope="{ row }">
            <span>{{ row.classNameLevel1 }}-{{ row.classNameLevel2 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="受理人"
          width="80"
          prop="acceptStaffName"></el-table-column>
        <el-table-column
          label="其他信息"
          min-width="480">
          <template slot-scope="{ row }">
            <div v-if="row.servicePackageId">
              <div v-if="row.labName">
                <span class="label">实验室：</span>{{ row.labName }}
              </div>
              <div v-if="row.testQualification">
                <span class="label">检测资质：</span> {{ row.testQualification }}
              </div>
              <div v-if="row.features">
                <span class="label">检测内容：</span>{{ row.features }}
              </div>
              <div v-if="row.testStandard">
                <span class="label">检测标准：</span> {{ row.testStandard }}
              </div>
              <div v-if="row.sampleQuantity">
                <span class="label">抽样数量：</span>{{ row.sampleQuantity }}
              </div>
              <div v-if="row.deliveryFullAddress">
                <span class="label">送样地址：</span>{{ row.deliveryFullAddress }}（{{ row.deliveryName }}-{{ row.deliveryPhone }}）
              </div>
              <div v-if="row.cycleDays">
                <span class="label">周期：</span>{{ row.cycleDays }}天
              </div>
              <div v-if="row.remarks">
                <span class="label">备注：</span>{{ row.remarks }}
              </div>
              <!-- <div>
                <span class="label">样码信息：</span>
                <el-popover
                  trigger="click">
                  <el-table
                    border=""
                    :data="row.samples">
                    <el-table-column
                      label="序号"
                      width="100"
                      prop="formatedTagNo"> </el-table-column>
                    <el-table-column
                      width="250"
                      label="标签码"
                      prop="tagCode"> </el-table-column>
                    <el-table-column
                      width="140"
                      label="抽样时间">
                      <template slot-scope="scope">
                        {{ scope.row.samplingTime | dateformat() }}
                      </template>
                    </el-table-column>
                  </el-table>
                  <el-link
                    slot="reference"
                    type="primary">{{ row.samplingCount }}个</el-link>
                </el-popover>
              </div> -->
            </div>
            <div v-else>
              <div>
                <span class="label">描述：</span>{{ row.features }}
              </div>
              <div>
                <span class="label">周期：</span>{{ row.cycleDays }}天
              </div>
              <div>
                <span class="label">备注：</span>{{ row.remarks }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="报告"
          width="170">
          <template slot-scope="{ row }">
            <span
              v-for="item in row.reportFile"
              :key="item">
              <el-image
                style="width: 60px;height: 60px"
                :src="item"
                fit="contain"
                :preview-src-list="row.reportFile">
              </el-image>
            </span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="!permission.LVL2"
          label="检测机构"
          min-width="100"
          prop="sgsName"></el-table-column>
        <el-table-column
          v-if="permission.LVL2"
          fixed="right"
          label="操作"
          width="105">
          <template slot-scope="{ row }">
            <el-dropdown>
              <el-button
                type="primary"
                style="margin-left:10px">
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-if="row.status === 1"
                  @click.native="completeitem(row)">直接完成</el-dropdown-item>
                <el-dropdown-item @click.native="uploaditem(row)">上传报告</el-dropdown-item>
                <el-dropdown-item
                  v-if="row.status === 1"
                  @click.native="updateitem(row)">编辑</el-dropdown-item>
                <el-dropdown-item
                  v-if="row.status === 1"
                  @click.native="deleteitem(row)">删除</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        slot="footer"
        background
        :current-page.sync="config.pageNum"
        :page-size="config.pageSize"
        layout="total, prev, pager, next"
        :total="totalNum"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </layout-card-wrap>
    <edit-acceptance-modal
      ref="acceptance"
      :callback="
        () => {
          getlist();
        }
      "
    />
    <vendor-select-modal
      ref="select"
      :callback="
        (r) => {
          additem(r);
        }
      "
    />
    <edit-result-modal
      ref="result"
      :callback="
        () => {
          getlist();
        }
      "
    />
  </layout-main-inner>
</template>
<script>
import { mapState } from 'vuex'
import EditAcceptanceModal from './edit-acceptance-modal.vue'
import VendorSelectModal from './vendor-select-modal.vue'
import EditResultModal from './edit-result-modal.vue'
import EntAutoSelect from '../../components/ent-auto-select.vue'

export default {
  name: 'AcceptanceIndex',
  components: { EditAcceptanceModal, VendorSelectModal, EditResultModal, EntAutoSelect },
  data() {
    return {
      loading: true,
      list: [],
      totalNum: 0,
      config: {
        pageNum: 1,
        pageSize: 10,
        workOrderCode: '',
        vendorId: null
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.account.userInfo,
      permission: (state) => state.account.permission
    })
  },
  mounted() {
    this.getlist()
  },
  methods: {
    uploaditem(row) {
      this.$refs.result.init({
        workOrderId: row.workOrderId,
        vendorName: row.vendorName,
        reportFile: row.reportFile.map(o => ({ url: o })),
        package: row.serviceName + '-' + row.serviceCategoryName + (row.servicePackageName ? '-' + row.servicePackageName : '')
      })
    },
    updateitem(row) {
      this.$refs.acceptance.update({
        workOrderId: row.workOrderId,
        vendorId: row.vendorId,
        vendorName: row.vendorName,
        serviceId: row.serviceId,
        classId: [row.classIdLevel1, row.classIdLevel2],
        serviceCategoryId: row.servicePackageId ? [row.serviceCategoryId, row.servicePackageId] : row.serviceCategoryId,
        sampleDeliveryAddressId: row.sampleDeliveryAddressId,
        labId: row.labId,
        features: row.features,
        testStandard: row.testStandard,
        testQualification: row.testQualification,
        sampleQuantity: row.sampleQuantity,
        cycleDays: row.cycleDays
      })
    },
    selectitem() {
      this.$refs.select.fetch()
    },
    additem(row) {
      console.log(row)
      this.$refs.acceptance.add({
        vendorId: row.vendorId,
        vendorName: row.vendorName
      })
    },
    completeitem(row) {
      this.$confirm('您确定完成该受理单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.$store.dispatch('account/completionworkorder', {
          payload: {
            workOrderId: row.workOrderId
          },
          success: () => {
            this.loading = false
            this.handleCurrentChange(1)
          },
          fail: () => {
            this.loading = false
          }
        })
      })
    },
    deleteitem(row) {
      this.$confirm('您确定删除该受理单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.$store.dispatch('account/deleteworkorder', {
          payload: {
            workOrderId: row.workOrderId
          },
          success: () => {
            this.loading = false
            this.handleCurrentChange(1)
          },
          fail: () => {
            this.loading = false
          }
        })
      })
    },
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.getlist()
    },
    getlist() {
      this.loading = true
      this.$store.dispatch('account/getworkorders', {
        payload: this.config,
        success: (res) => {
          this.loading = false
          this.totalNum = res.data.total
          this.list = res.data.records.map(i => ({
            ...i,
            cycleDays: i.cycleDays || undefined,
            reportFile: i.reportFile ? i.reportFile.split(',') : [],
            fileList: i.reportFile ? i.reportFile.split(',') : []
          }))
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
.label {
  color: #000;
}
</style>
